import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import {
  // HomeIcon,
  // SearchIcon,
  CreateIcon,
  PuzzleIcon,
} from '../icons/FeedIcons';

function MobileBottomNav() {
  const { user } = useContext(AuthContext);

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 h-12 bg-puzzle-surface border-t border-puzzle-border z-40 flex items-center justify-around px-4">
      {/* Hidden for now
      <NavLink to="/feed" className="p-2">
        {({ isActive }) => <HomeIcon filled={isActive} className="w-6 h-6 text-puzzle-text" />}
      </NavLink>

      <NavLink to="/feed" className="p-2">
        <SearchIcon className="w-6 h-6 text-puzzle-text" />
      </NavLink>
      */}

      <NavLink to="/create" className="p-2">
        <CreateIcon className="w-6 h-6 text-puzzle-text" />
      </NavLink>

      <NavLink to="/my-puzzles" className="p-2">
        {({ isActive }) => <PuzzleIcon filled={isActive} className="w-6 h-6 text-puzzle-text" />}
      </NavLink>

      <NavLink to={user ? '/profile/demo_user' : '/login'} className="p-2">
        <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold ${user ? 'bg-puzzle-muted text-puzzle-text-secondary' : 'bg-puzzle-muted'}`}>
          {user ? user.email?.charAt(0).toUpperCase() : ''}
        </div>
      </NavLink>
    </nav>
  );
}

export default MobileBottomNav;
